module.exports = __webpack_public_path__ + "static/media/360_icon.480a2eb4.svg";